'use strict';
const angular = require('angular');
const mustache = require('mustache');

export class templateWidgetComponent {

  constructor(SettingsService, DynamicPageService) {
    'ngInject';

    this.SettingsService = SettingsService;
    this.DynamicPageService = DynamicPageService;
  }

  $onInit() {

    let _METHOD = (this.public === 'true') ? "getPublicByName" : "getByName";

    this.SettingsService[_METHOD]({name: this.settings}, setting => {
      let templateVars = (this.key) ? setting.data[this.key] : setting.data;

      this.DynamicPageService[_METHOD]({name: this.template}, page => {
        let template = this.convertShortcode(page.data);
        this.html = mustache.render(template, templateVars);
      }, err => {
        console.log("could not retrieve template");
      });

    }, err => {
      console.log('could not retrieve data for template');
    });
  }
  
  convertShortcode(html) {
    return html.replace(/\[/g,"<").replace(/\]/g,">");
  }
}

export default angular.module('conduuApp.templateWidget', [])
  .component('templateWidget', {
    template: require('./template-widget.component.html'),
    bindings: {
      template: '@',
      settings: '@',
      key: '@',
      public: '@'
    },
    controller: templateWidgetComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/template-widget/template-widget.component.js